interface Props {
  disabled: boolean
  message: string
  contractPurchase: any
}

const MintingButton = ({ disabled, message, contractPurchase }: Props) => {
  return (
    <button
      disabled={disabled}
      onClick={() => contractPurchase?.()}
      className="gallery-btn-primary disabled:opacity-40 disabled:cursor-not-allowed font-sans text-sm font-medium min-w-[210px] py-3"
    >
      {message}
    </button>
  )
}

export default MintingButton
